import { track } from '@farmersdog/analytics';

import { segmentTrackEvents } from '../segmentTrackEventNames';
import { AnalyticsFlow, AnalyticsSite } from '../types';

export function trackFreshPerksViewedHeadline() {
  track(segmentTrackEvents.module_viewed, {
    site: AnalyticsSite.Main,
    module_name: 'better for them. easier for you.',
    flow: AnalyticsFlow.Signup,
  });
}
